import * as React from "react";
import { Row, Col } from "antd";
import StandardButton from "src/components/common/StandardButton/StandardButton";

const ContractSigned = () => {
  return (
    <div className="steps-container">
      <h1>Aguarde nosso contato</h1>
      <div className="steps-container-description">
        <p>Para a assinatura do contrato em cartório, um de nossos especialistas entrará em contato para realizar o agendamento.</p>
      </div>
      <Row>
        <Col xs={8} sm={8} md={8} lg={8}>
          <a target="_blank" href="https://blog.precatoriosbrasil.com/">
            <StandardButton style={{ maxWidth: "324px" }}>Ir para o Blog</StandardButton>
          </a>
        </Col>
        <Col xs={24} sm={24} md={2} lg={2} />
        <Col xs={8} sm={8} md={8} lg={8}>
          <a target="_blank" href="https://precatoriosbrasil.com/faq">
            <StandardButton preset="outline">FAQ</StandardButton>
          </a>
        </Col>
      </Row>
    </div>
  );
};

export default ContractSigned;



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/ContractSigned/ContractSigned.tsx